import { render } from "./RecordsRibbon.vue?vue&type=template&id=752f744d"
import script from "./RecordsRibbon.vue?vue&type=script&lang=js"
export * from "./RecordsRibbon.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.28.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__